'use client';

import { ColorShadesHex, Flex, Loader } from '@gsk-tech/react-ui-components';

export default function Loading() {
  return (
    <Flex justify="center" align="center" data-testid="navigation-progress-bar">
      <Loader
        color={ColorShadesHex['orange-100']}
        size="xl"
        style={{ position: 'absolute', top: '50%', left: '50%' }}
      />
    </Flex>
  );
}
